import { MapPin, Store } from "lucide-react";
import { useStoreColors } from "@/hooks/use-store-colors";

interface PublicUnit {
  id: string;
  name: string;
  address: string | null;
  whatsappNumber: string;
  isParent: boolean;
}

interface UnitSelectorProps {
  storeName: string;
  logoUrl: string | null;
  units: PublicUnit[];
  colorPrimary: string;
  colorSecondary: string;
  colorAccent: string;
  onSelect: (unitId: string) => void;
}

export function UnitSelector({
  storeName,
  logoUrl,
  units,
  colorPrimary,
  colorSecondary,
  colorAccent,
  onSelect,
}: UnitSelectorProps) {
  useStoreColors({ colorPrimary, colorSecondary, colorAccent });

  return (
    <div className="min-h-[100svh] bg-gray-50 flex flex-col">
      <div className="bg-primary pt-10 pb-8 px-6 text-center">
        {logoUrl ? (
          <img
            src={logoUrl}
            alt={storeName}
            className="w-20 h-20 rounded-full object-cover mx-auto mb-4 border-4 border-white/20 shadow-lg"
          />
        ) : (
          <div className="w-20 h-20 rounded-full bg-white/20 flex items-center justify-center mx-auto mb-4 shadow-lg">
            <Store className="w-10 h-10 text-white" />
          </div>
        )}
        <h1 className="text-xl font-bold text-white">{storeName}</h1>
        <p className="text-white/80 text-sm mt-2">
          Selecione a unidade
        </p>
      </div>

      <div className="flex-1 px-4 py-6 -mt-4">
        <div className="space-y-3 max-w-md mx-auto">
          {units.map((unit) => (
            <button
              key={unit.id}
              onClick={() => onSelect(unit.id)}
              className="w-full bg-white rounded-2xl border border-gray-200 p-5 text-left shadow-sm hover:shadow-md hover:border-primary/30 transition-all active:scale-[0.98]"
            >
              <p className="font-semibold text-gray-900 text-base">
                {unit.name}
              </p>
              {unit.address && (
                <p className="text-sm text-gray-500 mt-1.5 flex items-start gap-1.5">
                  <MapPin className="w-3.5 h-3.5 mt-0.5 flex-shrink-0 text-gray-400" />
                  <span>{unit.address}</span>
                </p>
              )}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
